import { render, staticRenderFns } from "./OnlineReservationSettingTab.vue?vue&type=template&id=43b330b4&scoped=true&lang=pug"
import script from "./OnlineReservationSettingTab.vue?vue&type=script&lang=ts"
export * from "./OnlineReservationSettingTab.vue?vue&type=script&lang=ts"
import style0 from "./OnlineReservationSettingTab.vue?vue&type=style&index=0&id=43b330b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b330b4",
  null
  
)

export default component.exports